import React, { FC, useMemo } from 'react';
import { useApiTenders } from 'src/models/procurements/Tenders/hooks';
import FilterOrgs from '../FilterOrgs';
import GenericSearchDropdown, { IGenericSearchDropdownProps } from '../../GenericSearchDropDown';
import { useTranslation } from 'react-i18next';
import styles from './index.module.scss';

export const FilterBuyer: FC<IGenericSearchDropdownProps> = props => {
  const { t } = useTranslation();
  const [{ vars }] = useApiTenders();

  const isChanged = useMemo(
    () => !!vars.buyerOrgIds?.length || !!vars.buyerSearchStrings?.length,
    [vars.buyerOrgIds?.length, vars.buyerSearchStrings?.length]
  );

  return (
    <GenericSearchDropdown
      {...props}
      label={t('Tenders.buyer')}
      overlay={<FilterOrgs />}
      overlayClassName={styles.overlay}
      isChanged={isChanged}
    />
  );
};

export default FilterBuyer;
